module.exports = "/assets/02342d9307184ce968a74fd02125ec36.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/LY.png
// module id = 2720
// module chunks = 0